/* File: src/pages/legal/Impressum.js
   Name: Impressum.js
   Zweck: Impressumsseite (rechtliche Informationen) für Experts4Germany.
*/

import React from 'react';

const Impressum = () => {
  return (
    <div className="p-5 text-white bg-gray-900 min-h-screen">
      <h1 className="text-3xl font-bold mb-4">Impressum</h1>
      
      <p>Angaben gemäß § 5 TMG:<br />
      Digital Nomads<br />
      - Markus Diehl -<br />
      Europe</p>
      
      <p>E-Mail: info@Experts4Germany.com<br />
      Web: www.Experts4Germany.com</p>
      
      <p>Vertreten durch den Geschäftsführer Markus Diehl</p>
      
      <p>Handelsregisternummer: HRB xxxxx (Hannover)</p>
      
      <p>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br />
      Digital Nomads<br />
      - Markus Diehl -<br />
      Europe<br />
      E-Mail: info@experts4germany.com</p>
      
      <p>Support: support@experts4germany.com</p>
      
      <h2 className="text-2xl font-bold mt-6">Bildquellen</h2>
      <p>https://www.sora.com</p>
      
      <h2 className="text-2xl font-bold mt-6">Haftungsausschluss</h2>
      <p>Nachfolgende Bestimmungen betreffen alle von Experts4Germany in jedweder Form betriebenen Webseiten. Dies beinhaltet u.a. auch Webseiten auf dem Portal der Firmen Facebook und Twitter.</p>
      
      <h3 className="text-xl font-bold mt-4">§ 1.0 Haftung für Inhalte</h3>
      <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
      
      <h3 className="text-xl font-bold mt-4">§ 1.1 Keine Abmahnung ohne vorherigen Kontakt</h3>
      <p>Sollte der Inhalt oder die Aufmachung der Seiten Rechte Dritter oder gesetzliche Bestimmungen verletzen, bitten wir um eine entsprechende Mitteilung ohne Kostennote. Wir sichern zu, dass zu Recht beanstandeten Teile umgehend entfernt werden, ohne dass die Einschaltung eines Rechtsbeistandes notwendig wird. Ohne vorherige Kontaktaufnahme ausgelöste Kosten oder Gebühren werden voll umfänglich zurückgewiesen. Gegebenenfalls wird Gegenklage wegen Verletzung vorgenannter Bestimmungen erhoben.</p>
      
      <p>Digital Nomads<br />
      - Markus Diehl -<br />
      Europe<br />
      E-Mail: info@experts4germany.com</p>
      
      <h3 className="text-xl font-bold mt-4">§ 2.0 Haftung für Links</h3>
      <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
      
      <h3 className="text-xl font-bold mt-4">§ 3.0 Urheberrecht</h3>
      <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
      
      <h3 className="text-xl font-bold mt-4">§ 4.0 Datenschutzerklärung gem DSGVO</h3>
      <p>Die Ausführungen zum Datenschutz gem DSGVO finden Sie unter dem Link “Datenschutzerklärung”.</p>
    </div>
  );
};

export default Impressum;
